// extracted by mini-css-extract-plugin
module.exports = {"breakpointTablet":"768px"};